exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#flotcontainer[data-v-f52aff0a]{width:600px;height:200px;text-align:left}", ""]);

// exports
